import React from "react";
import styled from "styled-components";

const Footer = () => {
  return (
    <Wrapper>
      <p>
        &#169; {new Date().getFullYear()} <span>Vilay Bende</span> All rights
        reserved
      </p>
    </Wrapper>
  );
};

const Wrapper = styled.footer`
  text-align: center;
  padding: 2rem;
  background-color: var(--color-black-1);
  color: var(--color-white);
  span {
    color: var(--color-primary-1);
  }
`;

export default Footer;
